import { MenuItem, TextField, Tooltip } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { SelectField } from "src/shared/components";
import { EAgencies } from "src/shared/types/common.types";
import { IPartnerContractDropdowns } from "src/shared/types/dropdowns";
import { messages } from "src/shared/utils/hookFormRules";
import { IPartnerComplexContractFormValues } from "../../../model/types";
interface IComplexContractFormCustomerBlockProps {
  customers_info?: IPartnerContractDropdowns["customers_info"];
  agency: EAgencies;
}

export function ComplexContractFormCustomerBlock({
  customers_info,
  agency,
}: IComplexContractFormCustomerBlockProps) {
  const { control, setValue } =
    useFormContext<IPartnerComplexContractFormValues>();

  return (
    <>
      <Controller
        control={control}
        name="customer_info.represented_by"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Tooltip title={field.value}>
            <SelectField
              inputRef={ref}
              fullWidth
              {...field}
              label="В лице"
              error={!!error}
              helperText={error?.message}
            >
              {customers_info?.[agency]?.map((item) => (
                <MenuItem
                  key={item.signer}
                  value={item.name}
                  onClick={() => {
                    setValue("customer_info.signs", item.signer, {
                      shouldValidate: true,
                    });
                    setValue("customer_info.bases_on", item.basis, {
                      shouldValidate: true,
                    });
                    setValue("customer_info.position", item.position, {
                      shouldValidate: true,
                    });
                  }}
                >
                  {item.name}
                </MenuItem>
              ))}
            </SelectField>
          </Tooltip>
        )}
        rules={{ required: messages.required }}
      />
      <Controller
        control={control}
        name="customer_info.position"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Tooltip title={field.value}>
            <TextField
              inputRef={ref}
              fullWidth
              {...field}
              label="Должность"
              error={!!error}
              helperText={error?.message}
            />
          </Tooltip>
        )}
      />
      <Controller
        control={control}
        name="customer_info.bases_on"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Tooltip title={field.value}>
            <TextField
              inputRef={ref}
              fullWidth
              {...field}
              label="На основании"
              error={!!error}
              helperText={error?.message}
            />
          </Tooltip>
        )}
      />
      <Controller
        control={control}
        name="customer_info.signs"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <Tooltip title={field.value}>
            <TextField
              inputRef={ref}
              fullWidth
              {...field}
              label="Подписывает"
              error={!!error}
              helperText={error?.message}
            />
          </Tooltip>
        )}
      />
    </>
  );
}
